import React from 'react';
type SectionLabelProps = {
  children: React.ReactNode;
  tone?: 'light' | 'dark';
};
export function SectionLabel({
  children,
  tone = 'light'
}: SectionLabelProps) {
  return <div className={`inline-flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.22em] ${tone === 'dark' ? 'text-cream/70' : 'text-clay'}`} data-id="element-164" data-mp="2yet2t5hjt6mi">
      <span className={`h-px w-6 ${tone === 'dark' ? 'bg-cream/40' : 'bg-clay'}`} aria-hidden="true" data-id="element-165" data-mp="33bje7fiere1l" />
      {children}
    </div>;
}